import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPlanVariationForSelection, ISystemModuleForSelection } from '../plan-selection-wizard/plan-selection.models';

export interface IBranchCompositionDialogData {
  branchTitle: string;
  solutionName?: string;
  variations: IPlanVariationForSelection[];
  modules: ISystemModuleForSelection[];
  selectedVariationIds: string[];
  selectedModuleIds: string[];
}

@Component({
  selector: 'app-plan-branch-composition-dialog',
  templateUrl: './plan-branch-composition-dialog.component.html',
  styleUrls: ['./plan-branch-composition-dialog.component.sass']
})
export class PlanBranchCompositionDialogComponent {
  selectedVariationIds = new Set<string>();
  selectedModuleIds = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<PlanBranchCompositionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IBranchCompositionDialogData
  ) {
    (data?.selectedVariationIds || []).forEach((id) => this.selectedVariationIds.add(String(id)));
    (data?.selectedModuleIds || []).forEach((id) => this.selectedModuleIds.add(String(id)));
  }

  variationId(item: IPlanVariationForSelection): string {
    return String(item?.id || item?.codigo || '').trim();
  }

  toggleVariation(item: IPlanVariationForSelection, checked: boolean): void {
    const id = this.variationId(item);
    if (!id) return;
    if (checked) this.selectedVariationIds.add(id);
    else this.selectedVariationIds.delete(id);
  }

  toggleModule(item: ISystemModuleForSelection, checked: boolean): void {
    const id = String(item?.id || '').trim();
    if (!id) return;
    if (checked) this.selectedModuleIds.add(id);
    else this.selectedModuleIds.delete(id);
  }

  save(): void {
    this.dialogRef.close({
      selectedVariationIds: Array.from(this.selectedVariationIds),
      selectedModuleIds: Array.from(this.selectedModuleIds),
    });
  }
}
